import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default function useRolesList({ root, emit }) {

  const toast = useToast()

  const refRolesListTable = ref(null)

  const roleToDelete = ref(null)

  const tableColumns = [
    { key: 'name', sortable: true, label: 'Name'},
    { key: 'privileges', sortable: true },
    { key: 'actions' },
  ]


  const perPage = ref(10)
  const totalRoles = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refRolesListTable.value ? refRolesListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRoles.value,
    }
  })

  const refetchData = () => {
    refRolesListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery], () => {

    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }
    refetchData()

  })


  const auth = store.getters['auth/user']

  const fetchRoles = (ctx, callback) => {
    requestStatus.value = true
    store
      .dispatch('roles/fetchRoles', {
        q: searchQuery.value,
        user: auth.id,
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        callback(response.data.roles.data)
        totalRoles.value = response.data.roles.meta.total
      })
      .catch(() => {
        requestStatus.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching ros list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }




  const goRemoveRole = () => {
    requestStatus.value = true
    store.dispatch('roles/deleteRole', roleToDelete.value)
      .then(() => {
        requestStatus.value = false
        refetchData()
        root.$bvToast.toast(root.$i18n.t("Successfully Delete Role"), {
            title: `Success`,
            variant: 'success', })
      }).catch(res =>   requestStatus.value = false)
  }


  return {
    goRemoveRole,
    roleToDelete,
    fetchRoles,
    tableColumns,
    perPage,
    currentPage,
    totalRoles,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRolesListTable,
    requestStatus,
    refetchData,

  }
}
